// extracted by mini-css-extract-plugin
export var dashboard = "style-module--dashboard--28e91";
export var doggosLoadingPulse = "style-module--doggosLoadingPulse--c54b1";
export var fill = "style-module--fill--3acc5";
export var illustration = "style-module--illustration--87b05";
export var inset = "style-module--inset--d6fd9";
export var page = "style-module--page--92955";
export var root = "style-module--root--7b4d8";